import React from 'react';
import { injectIntl } from 'react-intl-next';
import TermsAndPrivacyPolicy from './terms-and-privacy';
import { type PreprovisionLandingViewProps } from './types';
import messages from '../project-pages-improvement/messages';
import Button from '@atlaskit/button/new';
import Illustration from './illustration';
import * as Styled from './styled';
import { ConfluenceLogo } from '@atlaskit/logo';
import { MountEvent } from '@atlassian/analytics-bridge';

const PreprovisionLandingView = ({ intl, onTryClick, onViewed }: PreprovisionLandingViewProps) => (
	<Styled.MainContentWrapper>
		<div>
			<Styled.CenterContentWrapper>
				<Styled.ContentBox>
					<ConfluenceLogo appearance="brand" />
					<Styled.PageTitleStyleWrapper>
						{intl.formatMessage(messages.title)}
					</Styled.PageTitleStyleWrapper>
					<Styled.ListContainer>
						<Styled.ListItem>{intl.formatMessage(messages.feature1)}</Styled.ListItem>
						<Styled.ListItem>{intl.formatMessage(messages.feature2)}</Styled.ListItem>
						<Styled.ListItem>{intl.formatMessage(messages.feature3)}</Styled.ListItem>
					</Styled.ListContainer>
					<Button appearance="primary" onClick={onTryClick}>
						{intl.formatMessage(messages.tryItNow)}
					</Button>
				</Styled.ContentBox>
				<Styled.ContentBox>
					<Illustration />
				</Styled.ContentBox>
			</Styled.CenterContentWrapper>
		</div>
		<MountEvent onMount={() => onViewed()} />
		<TermsAndPrivacyPolicy />
	</Styled.MainContentWrapper>
);

export default injectIntl(PreprovisionLandingView);
